import React from "react";
import * as faceapi from '@vladmandic/face-api';
import { getDic } from '../assets/i18n/dictionary';
import FormRow from "./FormRow";
import FormColumn from "./FormColumn";
import TextSmall from "./TextSmall";
import moment from 'moment';

const Camera = ({
  onFaceDetect,
  labeledFaceDescriptors,
  width,
  height,
  useBackCamera = false,
  log,
  ...props
}) => {

  const videoRef = React.useRef();
  const lastDetectionsRef = React.useRef([]);
  const consistencyThreshold = 1;
  const [currentLog, setCurrentLog] = React.useState('Carregando');
  React.useEffect(() => {
    if (log) {
      log(currentLog)
    }
  }, [currentLog]);

  React.useEffect(() => {
    startVideo();
  }, [])

  const startVideo = () => {
    navigator.mediaDevices
      .getUserMedia({
        video: {
          width: 300,
          facingMode: useBackCamera ? 'environment' : 'user',
        }
      })
      .then(stream => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch(err => {
        console.error("error:", err);
      });
  }

  const handleVideoOnPlay = async () => {
    const faceMatcher = new faceapi.FaceMatcher(labeledFaceDescriptors);

    setInterval(async () => {
      setCurrentLog(`Olhe para a câmera`);

      const displaySize = {
        width: width || 640,
        height: height || 480
      }

      faceapi.matchDimensions(videoRef.current, displaySize);

      const detections = await faceapi
        .detectAllFaces(videoRef.current, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withFaceDescriptors();

      const resizedDetections = faceapi.resizeResults(detections, displaySize);

      const results = [];
      resizedDetections.map((d) => {
        if (checkIfFaceAreClose(d) && checkLandmarksPosition(d)) {
          results.push(faceMatcher.findBestMatch(d.descriptor));
        }
      });

      if (results.length > 0) {
        setCurrentLog(`Verificando Rosto`);

        results.sort((a, b) => a._distance - b._distance);
        const bestMatch = results[0];

        if (bestMatch._distance < 0.40) {
          // adicionar ao histórico
          lastDetectionsRef.current.push(bestMatch._label.toString());
          if (lastDetectionsRef.current.length > consistencyThreshold) {
            lastDetectionsRef.current.shift(); // mantém só os últimos N
          }

          // verificar consistência
          const allSame = lastDetectionsRef.current.every(
            (val) => val === lastDetectionsRef.current[0]
          );

          if (allSame && lastDetectionsRef.current.length === consistencyThreshold) {
            if (onFaceDetect) {
              onFaceDetect(bestMatch);
            }
          }
        } else {
          setCurrentLog(`Rosto não encontrado`);
        }
      }
    }, 1000);

    function checkIfFaceAreClose(d) {
      if (d.detection.score < 0.70) { return false }
      const _imageArea = d.detection.imageDims.width * d.detection.imageDims.height;
      const _boxArea = d.detection.box.width * d.detection.box.height;
      const _percentage = (_boxArea / _imageArea) * 100;
      return _percentage >= 20;
    }

    function checkLandmarksPosition(d) {
      const landmarks = d.landmarks.positions;
      const leftEye = landmarks[36];
      const rightEye = landmarks[45];
      const nose = landmarks[33];
      const mouth = landmarks[48];
      if (!leftEye || !rightEye || !nose || !mouth) {
        return false;
      }

      const eyesInBounds = leftEye.x >= d.detection.box.x && rightEye.x <= (d.detection.box.x + d.detection.box.width) &&
        leftEye.y >= d.detection.box.y && rightEye.y <= (d.detection.box.y + d.detection.box.height);

      if (!eyesInBounds) {
        return false;
      }
      return true
    }
  }

  const closeWebcam = () => {
    videoRef.current.pause();
    videoRef.current.srcObject.getTracks()[0].stop();
    // setCaptureVideo(false);
  }

  return (
    <FormColumn>
      <FormRow justifyContent='center'>
        <TextSmall>{currentLog}</TextSmall>
      </FormRow>
      <FormRow>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <video
            ref={videoRef}
            height={height || 480}
            width={width || 640}
            onPlay={handleVideoOnPlay}
            autoplay
            muted
            playsinline
            style={{ transform: !useBackCamera ? 'scaleX(-1)' : undefined }}
          />
        </div>
      </FormRow>
    </FormColumn>
  );
};

export default Camera;
